import './quote-support-inbox-view';
import {
  commandActionButton,
  delayedEvent,
  RefreshCommandAction
} from '../../../webmodule-common/other/ui/command-action';
import { customElement, query } from 'lit/decorators.js';
import { html } from 'lit';
import { PageControlTabWithIndependantSaving } from '../../../webmodule-common/other/ui/data-entry-screen-base';
import { PromiseTemplate, Snippet } from '../../../webmodule-common/interop/webmodule-interop';
import {
  SupportInboxItemStatus,
  SupportInboxItemType,
  ViewSupportInboxItemEx
} from '../../api/supplier-api-interface-franchiseenetwork';
import { WebModuleSupplierQuoteSupportInboxView } from './quote-support-inbox-view';

export interface QuoteSupportInboxViewOptions {
  tabName: string;
  caption: Snippet;
  typeFilter: SupportInboxItemType;
  statusFilter: SupportInboxItemStatus;
  eventLogin: (item: ViewSupportInboxItemEx) => Promise<void>;
  showResolvedColumns?: boolean;
  showLastModified?: boolean;
  showAssignedTo?: boolean;
  activeTerritoryBranchIds?: string[];
}

@customElement('wm-quotesupportinboxviewtab')
export class QuoteSupportInboxViewTab extends PageControlTabWithIndependantSaving {
  options: QuoteSupportInboxViewOptions;
  @query('.inbox-view')
  public inboxView: WebModuleSupplierQuoteSupportInboxView;
  private refreshAction = new RefreshCommandAction(delayedEvent(() => this.refreshTableData(), 2000));

  constructor(options: QuoteSupportInboxViewOptions) {
    super();
    this.options = options;

    this.pageFragment = options.tabName;
  }

  public async allowPageSwitch(): Promise<boolean> {
    return true;
  }

  public allowDeletePage(): boolean {
    return false;
  }

  async onEnter(): Promise<void> {
    await this.refreshTableData();
  }

  buttonMenu() {
    return html` ${commandActionButton(this.refreshAction)}`;
  }

  protected getCaption(): Snippet {
    return this.options.caption;
  }

  protected async bodyTemplate(): PromiseTemplate {
    const eventQuoteReview = async (e: CustomEvent<{ item: ViewSupportInboxItemEx }>) => {
      e.stopImmediatePropagation();
      e.preventDefault();
      this.options.eventLogin(e.detail.item);
    };
    // The table (DataTableWrapper) owns its own filter row (text search + ticket
    // owner) and pagination, so the tab just hosts it.
    return html`<wm-webmodulesupplierquotesupportinboxview
      class="inbox-view"
      .typeFilter=${this.options.typeFilter}
      .statusFilter=${this.options.statusFilter}
      .showAssignedTo=${this.options.showAssignedTo}
      .showLastModified=${this.options.showLastModified}
      .showResolvedColumns=${this.options.showResolvedColumns}
      .activeTerritoryBranchIds=${this.options.activeTerritoryBranchIds}
      @wm-supportinbox-quotereview=${eventQuoteReview}
    ></wm-webmodulesupplierquotesupportinboxview>`;
  }

  private async refreshTableData() {
    if (this.inboxView) await this.inboxView.refreshData();
  }
}
